var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCandidateIcon = function SvgCandidateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.192 19.189a3.181 3.181 0 0 0-.578 0c-4.165-.14-7.472-3.553-7.472-7.753a7.764 7.764 0 0 1 7.77-7.77 7.775 7.775 0 0 1 7.77 7.77c-.018 4.2-3.325 7.613-7.49 7.753ZM28.88 7.166a6.12 6.12 0 0 1 6.125 6.125 6.133 6.133 0 0 1-5.898 6.125 1.977 1.977 0 0 0-.455 0M7.442 25.646c-4.235 2.835-4.235 7.455 0 10.273 4.812 3.22 12.705 3.22 17.517 0 4.235-2.835 4.235-7.455 0-10.273-4.795-3.202-12.687-3.202-17.517 0ZM32.257 35.166c1.26-.262 2.45-.77 3.43-1.522 2.73-2.048 2.73-5.425 0-7.473-.963-.735-2.135-1.225-3.378-1.505",
    stroke: "currentcolor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgCandidateIcon;